import { showToast } from '@maia/ui';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  getCustomerOptions,
  useUpdateBillingCycle,
  useUpdateIban,
} from './../../../../../features/customer/customer/queryOptions';
import { EditPaymentForm } from './../../../../../features/edit-customer/payment-form';
import { queryClient } from './../../../../../main';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/edit/_layout/payment',
)({
  component: RouteComponent,
  loader: ({ context: { queryClient }, params: { guid } }) =>
    queryClient.ensureQueryData(getCustomerOptions(guid)),
});

function RouteComponent() {
  const params = Route.useParams();
  const { data } = useQuery(getCustomerOptions(params.guid));

  const navigate = useNavigate();

  const { mutateAsync: updateBillingCycle, isPending: isPendingBillingCycle } =
    useUpdateBillingCycle(
      params.guid,
      () => {
        showToast({
          intent: 'success',
          title: 'De facturatiecyclus is verandert!',
          config: { position: 'top-right' },
        });

        queryClient.invalidateQueries({
          queryKey: ['customers', 'customer', params.guid],
        });
      },
      () => {
        showToast({
          intent: 'error',
          title: 'Er ging iets mis',
          description:
            'We konden de facturatiecyclus niet veranderen. Probeer het later opnieuw',
          config: { position: 'top-right' },
        });
      },
    );

  const { mutateAsync: updateIban, isPending: isPendingIban } = useUpdateIban(
    params.guid,
    () => {
      showToast({
        intent: 'success',
        title: 'De iban is verandert!',
        config: { position: 'top-right' },
      });

      queryClient.invalidateQueries({
        queryKey: ['customers', 'customer', params.guid],
      });

      navigate({ to: `/customers/$guid`, params: { guid: params.guid } });
    },
    () => {
      showToast({
        intent: 'error',
        title: 'Er ging iets mis',
        description:
          'We konden de iban niet veranderen. Probeer het later opnieuw',
        config: { position: 'top-right' },
      });
    },
  );

  return (
    <div className="area-page-content content-grid max-form-width">
      {data && (
        <EditPaymentForm
          customer={data}
          isLoading={isPendingBillingCycle || isPendingIban}
          isPending={isPendingBillingCycle || isPendingIban}
          onSubmit={(value) => {
            if (value.cycle !== data?.billingUnit.interval) {
              updateBillingCycle({ cycle: value.cycle });
            }
            if (value.iban !== data?.iban) {
              updateIban({ iban: value.iban });
            }
          }}
        />
      )}
    </div>
  );
}
